import React, { useEffect, useState } from 'react';

import { SecondaryBase } from './../Commons/SecondaryBase';


const Stadium = ({ getOutOfTheDynamic }) => {
    const [liveStats, setLiveStats] = useState(null);
    const [isWorking, setIsWorking] = useState(false);
    const [newRoundName, setNewRoundName] = useState('');

    // Traductor visual para el Admin
    const getVisualZoneName = (realZoneName) => {
        if (!realZoneName) return '';
        const normalized = realZoneName.toLowerCase().trim();
        // Si estamos en la ronda de Daikin, aplicamos la máscara
        if (liveStats?.roundName?.toLowerCase().includes('daikin')) {
            const aliases = {
                'laboratorio tequis': 'Pichon-kun', 'canels': 'Pichon-kun', 'seguros el potosi': 'Pichon-kun', 'nissan': 'Pichon-kun', 'lounge ron potosi': 'Pichon-kun', 'azul': 'Pichon-kun',
                'red cola': 'Tunita', 'tecate': 'Tunita', 'moctezuma': 'Tunita', 'mobil': 'Tunita', 'oro': 'Tunita'
            };
            return aliases[normalized] || realZoneName;
        }

        const defaultAliases = {
            'zona1': 'Team Eldo Local',
            'zona 1': 'Team Eldo Local',
            'eldo local': 'Team Eldo Local',
            'team eldo local': 'Team Eldo Local',
            '1': 'Team Eldo Local',
            'lucho': 'Team Eldo Local',
            'team lucho': 'Team Eldo Local',

            'zona2': 'Team Eldo Visitante',
            'zona 2': 'Team Eldo Visitante',
            'eldo visitante': 'Team Eldo Visitante',
            'team eldo visitante': 'Team Eldo Visitante',
            '2': 'Team Eldo Visitante',
            'tunita': 'Team Eldo Visitante',
            'team tunita': 'Team Eldo Visitante'
        };

        return defaultAliases[normalized] || realZoneName.replace(/\b\w/g, l => l.toUpperCase());
    };

    const fetchStats = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}Stadium/LiveStats`);
            if (res.ok) setLiveStats(await res.json());
        } catch (e) { console.error("Error fetching stats", e); }
    };

    useEffect(() => {
        fetchStats();
        // Refrescar automáticamente cada 5 segundos
        const interval = setInterval(fetchStats, 5000);
        return () => clearInterval(interval);
    }, []);

    const handleStartNewRound = async () => {
        if(!newRoundName) return alert("Escribe un nombre para la ronda");
        if(!window.confirm(`🚨 ¡ATENCIÓN!\n\nEstás a punto de iniciar "${newRoundName}".\n\nEsto desconectará INMEDIATAMENTE a todas las personas en el estadio de sus celulares y limpiará los contadores a 0.\n\n¿Proceder?`)) return;

        setIsWorking(true);
        try {
            await fetch(`${process.env.REACT_APP_API_URL}Stadium/StartNewRound`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roundName: newRoundName })
            });
            setNewRoundName('');
            fetchStats();
            alert("¡Purga ejecutada! El estadio está listo para la nueva ronda.");
        } catch (e) {
            alert("Error al iniciar ronda");
        } finally {
            setIsWorking(false);
        }
    };


    return (
        <SecondaryBase actionToExecute={getOutOfTheDynamic}>
            <section className='p-4 bg-light rounded shadow-sm h-100'>
                <h2 className="fw-black mb-4"><i className="bi bi-broadcast"></i> Centro de control del estadio</h2>

                <div className="row g-4">
                    {/* PANEL DE CONTROL DE DINÁMICAS (LA PURGA) */}
                    <div className="col-md-4">
                        <div className="card border-danger shadow-sm h-100">
                            <div className="card-header bg-danger text-white fw-bold">
                                Control de Fases
                            </div>
                            <div className="card-body">
                                <p className="small text-muted">Inicia una nueva fase para resetear a todos los usuarios, limpiar sus cachés y actualizar los nombres de las zonas (Ej. Trivia -> Daikin).</p>
                                <input 
                                    type="text" 
                                    className="form-control mb-3" 
                                    placeholder="Nombre (Ej. 'Tiro Daikin')" 
                                    value={newRoundName} 
                                    onChange={(e) => setNewRoundName(e.target.value)}
                                />
                                <button className="btn btn-danger w-100 fw-bold shadow" onClick={handleStartNewRound} disabled={isWorking}>
                                    <i className="bi bi-power"></i> INICIAR NUEVA FASE Y PURGAR ZOMBIES
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* DASHBOARD ANALÍTICO */}
                    <div className="col-md-8">
                        <div className="card shadow-sm h-100 border-0">
                            <div className="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
                                <span>Estadísticas en Vivo</span>
                                <button className="btn btn-sm btn-outline-light" onClick={fetchStats}><i className="bi bi-arrow-clockwise"></i> Actualizar</button>
                            </div>
                            <div className="card-body">
                                {liveStats ? (
                                    <>
                                        <h5 className="fw-bold text-primary mb-3">Ronda Activa: {liveStats.roundName}</h5>
                                        
                                        <div className="row text-center mb-4 g-2">
                                            <div className="col">
                                                <div className="p-3 bg-light rounded border">
                                                    <h2 className="fw-black text-success mb-0">{liveStats.totalCurrentlyActive}</h2>
                                                    <span className="small text-muted">JUGADORES AHORA</span>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="p-3 bg-light rounded border">
                                                    <h2 className="fw-black text-secondary mb-0">{liveStats.totalEverConnected}</h2>
                                                    <span className="small text-muted">TOTAL HISTÓRICO (Entraron)</span>
                                                </div>
                                            </div>
                                        </div>

                                        <table className="table table-hover table-sm border align-middle text-center">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-start">ZONA</th>
                                                    <th>ACTIVOS AHORA</th>
                                                    <th>ENTRARON EN TOTAL</th>
                                                    <th>ABANDONARON</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {liveStats.zoneStats.map((z, i) => (
                                                    <tr key={i}>
                                                        {/* <td className="text-start fw-bold text-uppercase">{z.zone}</td> */}
                                                        <td className="text-start fw-bold text-uppercase">{getVisualZoneName(z.zone)}</td>
                                                        <td className="fs-5 text-success fw-bold">{z.currentActive}</td>
                                                        <td>{z.totalEntered}</td>
                                                        <td className="text-danger">{z.totalLeft}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                ) : (
                                    <div className="text-center p-5 text-muted">
                                        <div className="spinner-border mb-3" role="status"></div>
                                        <p>Cargando datos del estadio...</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </SecondaryBase>
    );
};

export { Stadium };